import identity from "lodash/fp/identity";

class SettingsPageTransform {
  constructor() {
    "ngInject";
  }

  justify(data) {
    return identity(data);
  }
}

export default SettingsPageTransform;



// WEBPACK FOOTER //
// ./src/pages/settings/settings.transforms.js